import { Dispatch, SetStateAction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SortingState } from '@tanstack/react-table';
import { NumberOfOrdersPerEmployeeReportUser } from '@durma-soft/gros-sdk/dist/types/reports';

import { DataTable, DataTableHTML } from '@/components/shared/data-table';

import { columns } from '@/config/company/reports/number-of-company-customer-orders';
import { LocationType } from '@durma-soft/gros-sdk';

interface NumberOfCustomerCompanyOrdersProps {
  forPrint?: boolean;
  sorting?: SortingState;
  setSorting?: Dispatch<SetStateAction<SortingState>>;
  locationType: LocationType;
  isTableSyncReference?: boolean;
  users: NumberOfOrdersPerEmployeeReportUser[];
}

export const NumberOfCustomerCompanyOrders = ({
  users,
  sorting,
  setSorting,
  locationType,
  forPrint = false,
  isTableSyncReference,
}: NumberOfCustomerCompanyOrdersProps) => {
  const { t } = useTranslation();

  const memoizedColumns = useMemo(
    () => columns(t, locationType),
    [t, locationType],
  );

  return (
    <>
      {!forPrint ? (
        <DataTable
          data={users}
          sorting={sorting}
          setSorting={setSorting}
          columns={memoizedColumns}
          isSyncReference={isTableSyncReference}
        />
      ) : (
        <DataTableHTML
          data={users}
          sorting={sorting}
          setSorting={setSorting}
          columns={memoizedColumns}
          columnVisibility={{ details: false }}
        />
      )}
    </>
  );
};
